import { getActivityColor } from '@/utils/activityColor';

// Copy for a productivity gauge's status pill + subtext. Reuses
// getActivityColor's tier *boundaries* so "what counts as good performance"
// stays consistent with Timeline, but the gauge's ring color is a fixed
// indigo regardless of tier (matching DashboardOverviewNew's gauge language)
// — only this label/subtext copy changes per tier, so this returns text only.
const STATUS_BY_TIER = {
  green: {
    label: 'Excellent',
    subtext: 'Outstanding work today!',
  },
  blue: {
    label: 'Good',
    subtext: "Keep it up! You're doing great.",
  },
  yellow: {
    label: 'Fair',
    subtext: "There's room to improve.",
  },
  red: {
    label: 'Needs Focus',
    subtext: "Let's turn it around today.",
  },
};

export const getProductivityStatus = (activityPct) => {
  return STATUS_BY_TIER[getActivityColor(activityPct)] || STATUS_BY_TIER.red;
};
